import React, {useRef, forwardRef, useState, useEffect, Fragment} from 'react'
import {useDispatch, useSelector} from "react-redux"
import MaterialTable from 'material-table'

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'

// Material-UI Lab
// import ToggleButton from '@material-ui/lab/ToggleButton'

// Material-UI Icon
import EditIcon from '@material-ui/icons/Edit'
// For Material-Table
import AddBox from '@material-ui/icons/AddBox'
import ArrowDownward from '@material-ui/icons/ArrowDownward'
import Check from '@material-ui/icons/Check'
import ChevronLeft from '@material-ui/icons/ChevronLeft'
import ChevronRight from '@material-ui/icons/ChevronRight'
import Clear from '@material-ui/icons/Clear'
import DeleteOutline from '@material-ui/icons/DeleteOutline'
import Edit from '@material-ui/icons/Edit'
import FilterList from '@material-ui/icons/FilterList'
import FirstPage from '@material-ui/icons/FirstPage'
import LastPage from '@material-ui/icons/LastPage'
import Remove from '@material-ui/icons/Remove'
import SaveAlt from '@material-ui/icons/SaveAlt'
import Search from '@material-ui/icons/Search'
import ViewColumn from '@material-ui/icons/ViewColumn'


// Custom Component
import useLoading from "../Loading/useLoading"
import FullScreenDialog from '../Dialog/FullScreenDialog'
import ViewRelatedItemForm from "./ViewRelatedItemForm"

// Custom Style
import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, grayColor, blueColor, nightOrangeColor, oceanBlueColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import drawingRelatedItemTableStyle from '../../styles/jss/components/drawingRegister/drawingRelatedItemTableStyle'

// Fetch Data
import {getRelatedItems} from '../../dataSource/drawingRegister'



const useStyles = makeStyles(theme => drawingRelatedItemTableStyle(theme))

const DrawingRelatedItemTable = props => {
	const {relatedItemType, drawingDetailRecord, selectedRevisionSeq, setDrawingRefash, relatedItemRefash} = props
	const store = require('store')
	const classes = useStyles()

	// State Variable
	const [relatedItemRecord, setRelatedItemRecord] = useState([])
	const [selectedRow, setSelectedRow] = useState(null)
	const [selectedRowRecord, setSelectedRowRecord] = useState(null)
	const [actionsIcon, setActionsIcon] = useState([])
	const [dataTableToolbarOpen, setDataTableToolbarOpen] = useState(false)
	const [viewRelatedItemDialogOpen, setViewRelatedItemDialogOpen] = useState(false)


	const tableIcons = {
		Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
		Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
		Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
		Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
		DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
		Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
		Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
		Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
		FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
		LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
		NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
		PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
		ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
		Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
		SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
		ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
		ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
	}

	const columns = [
		{title: "Item Type", field: "type_name", width: "10%"},
		{title: "Item No.", field: "rel_no", width: "10%"},
		{title: "Description", field: "rel_desc", width: "60%"},
		{title: "Create User", field: "createuser", width: "10%"},
		{title: "Create Date", field: "createdate", width: "10%"},
	]


	const viewRelatedItemDialogHandleOpen = () => {
		setViewRelatedItemDialogOpen(true)
	}

	const viewRelatedItemDialogHandleClose = () => {
		setViewRelatedItemDialogOpen(false)
	}


	const drawingDetailDialogBtn = [
		// {
		// 	buttonName: "Annotation Publish",
		// 	buttonFunction: annotationPublishActionHandleOpen,
		// 	chooseFile: false
		// },
	]


	useEffect(() => {
		getRelatedItems(drawingDetailRecord.dwg_seq, selectedRevisionSeq).then(res => {
			setRelatedItemRecord(res.data[relatedItemType])
		})
	}, [relatedItemRefash])


	return (
		// console.log("Related Item Records | Variable: relatedItemRecord (DrawingDetailRelatedItemTable.js)"),
		// console.log(relatedItemRecord),

		// console.log("Selected Related Item Record | Variable: selectedRowRecord (DrawingDetailRelatedItemTable.js)"),
		// console.log(selectedRowRecord),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<div>
				<FullScreenDialog
					open={viewRelatedItemDialogOpen}
					dialogTitle={relatedItemType === "Sketches" ? "Sketches Item Detail" : relatedItemType === "RelatedItems" ? "Related Item Detail" : "Related Item Detail"}

					formContent={
						<ViewRelatedItemForm
							drawingDetailRecord={drawingDetailRecord}
							selectedRevisionSeq={selectedRevisionSeq}
							selectedRelatedItemSeq={selectedRowRecord ? selectedRowRecord.relative_seq : ""}
							viewRelatedItemDialogHandleClose={viewRelatedItemDialogHandleClose}
							setDrawingRefash={setDrawingRefash}
						/>
					}

					button={[]}
					handleClose={viewRelatedItemDialogHandleClose}
				/>
			</div>

			<MaterialTable
				icons={tableIcons}
				title=""
				columns={columns}
				data={relatedItemRecord}
				actions={actionsIcon}

				onSelectionChange={(data) => {
					if (data.length > 0) {
						if (data.length === 1) {
							setActionsIcon([
								{
									icon: () => <EditIcon color="primary"/>,
									tooltip: 'Edit',
									onClick: (event, rowData) => {
										console.log("Press Edit: ", rowData)
									}
								},
							])
						}
						else {
							setActionsIcon([])
						}

						setDataTableToolbarOpen(true)
					}
					else {
						setDataTableToolbarOpen(false)
					}
				}}

				// onSearchChange={handleSearchChange}
				// onFilterChange={handleFilterChange}

				onRowClick={(event, selectedRow) => {
					setSelectedRow(selectedRow.tableData.id)
					setSelectedRowRecord(selectedRow)

					viewRelatedItemDialogHandleOpen()
				}}
				
				localization={{
					header : {
						actions: ""
					}
				}}

				options={{
					showTitle: false,
					toolbar: dataTableToolbarOpen,
					grouping: true,
					paging: false,
					selection: false,

					search: false,
					filtering: true,

					headerStyle: {
						backgroundColor: oceanBlueColor[10],
						fontFamily: "Gill Sans, sans-serif",
						fontWeight: "bold",
						fontSize: "16px",
						color: whiteColor,
					},

					rowStyle: rowData => ({
						backgroundColor: selectedRow === rowData.tableData.id ? oceanBlueColor[0] : "",
						fontSize: "14px",
						fontFamily: "Gill Sans, sans-serif",
					}),
				}}
			/>
		</Fragment>
	)
}


export default DrawingRelatedItemTable